module.exports = __webpack_public_path__ + "assets/img/tether.b0b30633.svg";